export enum RiskActionStatuses {
  NotStarted = 1,
  InProgress = 2,
  Complete = 3,
  Slipped = 4,
}
